module.exports = __webpack_public_path__ + "img/2.e85ee591.jpg";